import { GQLBaseOrderFragment, GQLOrderFragment, GQLOrderTileFragment } from '@theprintbar/graphql';

export function isOrderFragment(order: GQLOrderFragment | GQLOrderTileFragment | GQLBaseOrderFragment): order is GQLOrderFragment {
	return (
		!!(order as GQLOrderFragment).items?.length || !!(order as GQLOrderFragment).events?.length || !!(order as GQLOrderFragment).payment
	);
}
